<script lang="ts" module>
  import type { ActionComponentProps } from '@agapi/ui/utils';
  export interface BlogCardProps extends ActionComponentProps {
    title: string;
    description?: string;
    imageUrl?: string;
    imageAlt?: string;
    author?: string;
    category?: string;
    slug: string;
    readingTime?: number;
    publishedAt: string;
    css?: Styles;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';
  import { Card, CardImage, CardHeader, CardContent, CardFooter } from '@agapi/ui/card';
  import { css, type Styles } from '@agapi/ui/panda/css';

  import { getLocaleFromUrl, formatDate, rewriteUrl } from '../../../utils/locale.shared';

  import { blogCardStyles } from './blog-card.styles';

  const { use, readingTime, title, description, imageUrl, imageAlt, publishedAt, category, slug, css: cssProp }: BlogCardProps = $props();

  const classes = blogCardStyles.raw();

  import * as m from '$lib/parachute/messages';


</script>

<a href={rewriteUrl(page, `/blog/${slug}`)}>
  <Card use={use} css={{...classes.root, ...cssProp}} spacing="snug">
    {#if imageUrl}
      <CardImage src={imageUrl} background={imageUrl + '/m/16x16'} alt={imageAlt || title} />
    {/if}
    <CardHeader css={classes.header}>
      <div class={css(classes.meta)}>
        {#if publishedAt}
          <span>{formatDate(publishedAt, getLocaleFromUrl(page.url))}</span>
        {/if}
        {#if publishedAt && readingTime}
          <span>•</span>
        {/if}
        {#if readingTime}
          <span>{readingTime} {m.minReading()}</span>
        {/if}
        <span>•</span>
        {#if category}
          <span> {category}</span>
        {/if}
      </div>
      <h3 class={css(classes.title)}>{title}</h3>
    </CardHeader>
    <CardContent css={classes.content}>
      <span class={css(classes.description)}>{description}</span>
    </CardContent>
    <CardFooter />
  </Card>
</a>
